export default "__VITE_ASSET__DZrsgB$p__"